<template>
    <div class="wrapper-div">
        <div class="article-dialog extend-bottom" :style="{ 'max-width': width + 'px' }">
            <div style="position: relative; top: 42px; left: 20px; width: calc(100% - 40px)">
                <IconBtn
                    class="primary-outlined closeBtnWrapper"
                    name="times"
                    size="lg"
                    style="float: right"
                    @click="closeDialog"
                ></IconBtn>
            </div>
            <Paper
                style="width: 100%;"
                class="d-flex flex-column flex-grow"
                :header="$t('calendar.aboutAppointments.header')"
                restrict-header-width
            >
                <div class="px-5 pb-5 pt-4 flex-grow">
                    <h5>
                        {{ $t('calendar.aboutAppointments.block1.header') }}
                    </h5>
                    <p>
                        {{ $t('calendar.aboutAppointments.block1.paragraph1') }}
                    </p>
                    <p>
                        {{ $t('calendar.aboutAppointments.block1.paragraph2') }}
                    </p>
                    <h5>
                        {{ $t('calendar.aboutAppointments.block2.header') }}
                    </h5>
                    <p>
                        {{ $t('calendar.aboutAppointments.block2.paragraph1') }}
                    </p>
                    <p>
                        {{ $t('calendar.aboutAppointments.block2.paragraph2') }}
                    </p>
                </div>
            </Paper>
        </div>
    </div>
</template>

<script>
// Utils
import AnalyticService from '~/services/AnalyticService';

export default {
    name: 'CalendarAboutDialog',

    props: {
        suppressLogging: Boolean,
    },

    data() {
        return {
            height: 600,
            width: 600,

            hasLoggedEvent: false, // Indicates if there has been a log of the article view
        };
    },

    computed: {},

    methods: {
        closeDialog() {
            this.$interfaces.dialogModal.getState().resolver.res();
        },

        handleResizeEvent() {
            this.height = window.innerHeight * 0.9;
            this.width = window.innerWidth;
        },

        stepBackHistory() {
            this.$interfaces.dialogModal.popState();
        },

        async logAboutViewEvent() {
            // if (this.suppressLogging) {
            //     return;
            // }
            //
            // const article = this.article ? this.article.data : null;
            //
            // // Not log if already logged, or if there is no data to log with
            // if (this.hasLoggedEvent || (!article || !article.id)) {
            //     return;
            // }
            //
            // // Making sure the company-data is fetched before we log
            // const company = await this.$interfaces.company
            //     .id(this.$route.params.id)
            //     .get();
            // if (!company || !company.data || !company.data.id) {
            //     return;
            // }
            //
            // // Start logging
            // this.hasLoggedEvent = true;
            // AnalyticService.articleViewEvent(
            //     article.id,
            //     company.data.id,
            //     article.title
            // );
            // TODO: Track this
            //console.log('Track');
        },
    },

    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.handleResizeEvent);
        });
        this.handleResizeEvent();

        // Logging article view event. Will not log if the data is not in there store.
        // Therefore, this method is also being called in watch when the data has been fetched.
        this.logAboutViewEvent();
    },

    destroyed() {
        window.removeEventListener('resize', this.handleResizeEvent);
    },

    watch: {
        // article(newArticle, oldArticle) {
        //     if (!this.hasLoggedEvent || newArticle.ids !== oldArticle.ids) {
        //         this.logAboutViewEvent();
        //     }
        // },
    },
};
</script>

<style lang="css" scoped>
.article-dialog {
    max-width: var(--grid-width);
    width: var(--grid-width);
    margin: 0 auto;
}

.wrapper-div {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
}

.article-img {
    width: 100%;
    max-height: 600px;
    object-fit: cover;
    padding: 12px;
}
</style>
